<template>
  <div>
    <area-chart
      :info-card="computedInfoCards"
      :data-series="computedSeries"
      :time-stamps="timeStamps"
      :format-percentage="true"
    />
  </div>
</template>

<script>
import AreaChart from '../widgets/AreaChart.vue'

export default {
  components: { AreaChart },
  data() {
    return {}
  },
  computed: {
    trafficStats() {
      return this.$store.state.storageAnalytics.trafficStats.stats ?? []
    },
    loadingTrafficStats() {
      return this.$store.state.storageAnalytics.loadingTrafficStats
    },
    peakComputed() {
      const data = this.computedSeries.map(x => x.data)[0]
      const peak = data.length !== 0 ? Math.max(...data) : 0
      const peakIndex = data.indexOf(peak)

      return {
        peak,
        peakTime: (this.computedSeries.map(x => x.timestamps)[0])[peakIndex],
      }
    },
    totalComputed() {
      const data = this.computedSeries.map(x => x.data)[0]

      return data.reduce((accumulator, currentValue) => accumulator + currentValue, 0)
    },
    computedInfoCards() {
      const infoCard = [
        {
          id: 1,
          title: 'Peak',
          description: this.formatBytes(this.peakComputed.peak),
          loading: this.loadingTrafficStats,
        },
        {
          id: 2,
          title: 'Peak Time',
          description: this.unixTimestampToDateTime(this.peakComputed.peakTime),
          loading: this.loadingTrafficStats,
        },
        {
          id: 3,
          title: 'Total Traffic',
          description: this.formatBytes(this.totalComputed),
          loading: this.loadingTrafficStats,
        },
      ]
      return infoCard
    },
    computedSeries() {
      return this.getFormattedSeries(this.trafficStats)
    },
    timeStamps() {
      if (this.trafficStats && this.trafficStats.length > 0) {
        return this.trafficStats.map(x => x.timestamp)
      }

      return null
    },
  },
  methods: {
    getFormattedSeries(dataList) {
      const series = [{
        name: 'Traffic',
        data: dataList?.map(item => item.value) || [],
        timestamps: dataList?.map(item => item.timestamp) || [],
      }]

      return series
    },
  },
}
</script>
